<template>
  <div
    :class="{
      'hyp-footer-logo-holder': !collapsed,
    }"
  >
    <div class="hyp-logo-grd-text pb-1" v-if="!collapsed">
      <div>Powered by</div>
      <div>
        <v-img
          :width="100"
          :height="100"
          :src="src"
          alt="hyperion logo"
          class="hyp-logo"
        ></v-img>
      </div>
    </div>

    <div class="hyp-logo-grd-text-copyright px-1" v-if="!collapsed">
      <div>
        &copy; 2022 Seerist, Inc.™ <br />
        All Rights Reserved Analysis by Control Risks unless otherwise
        indicated.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LogoGrdFooter",
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    src() {
      return require(`@/assets/images/seerist_logo.png`);
    },
  },
};
</script>

<style scoped>
.hyp-footer-logo-holder {
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.hyp-logo-grd-text {
  margin: 10px auto auto auto;
  text-align: center;
  font-size: 0.88rem;
  color: #003947;
}

.hyp-logo-grd-text-copyright {
  margin: auto;
  text-align: left;
  font-size: 0.7rem;
  color: #003947;
  line-height: 1rem;
  margin: 0 0.5rem;
}

.hyp-logo-grd-text div:nth-child(2) {
  font-size: 22px;
}
.hyp-logo {
  margin: auto;
}
</style>
